import { twoDigits, getDaysInMonth } from '@H/enrolment';

export default {
    data() {
        return {
            day: false,
            month: false,
            year: false,
            days: 31,
            months: [
                this.$gettext('January'),
                this.$gettext('February'),
                this.$gettext('March'),
                this.$gettext('April'),
                this.$gettext('May'),
                this.$gettext('June'),
                this.$gettext('July'),
                this.$gettext('August'),
                this.$gettext('September'),
                this.$gettext('October'),
                this.$gettext('November'),
                this.$gettext('December')
            ]
        };
    },
    computed: {
        formattedDob() {
            return `${this.year}-${this.month}-${twoDigits(this.day)}`;
        }
    },
    methods: {
        stripDob(str) {
            return str.split('-')[1];
        },
        dobHandler(e) {
            let el = e.target || e;
            let key = this.stripDob(el.name);
            let val;
            if (key === 'month') {
                val = twoDigits(
                    this.months.indexOf(e.value || e.target.value) + 1
                );
            } else {
                val = e.value || e.target.value;
            }
            this[key] = val;

            const days = getDaysInMonth(this.month, this.year);

            this.days = days;

            // this.$set(this.$data, 'days', days);
        },

    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/dob.js